import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

interface EditorProps {
	value: string
	onChange: (value: string) => void
	placeholder?: string
	className?: string
}

const modules = {
	toolbar: [
		[{ header: [1, 2, 3, 4, 5, 6, false] }],
		['bold', 'italic', 'underline', 'strike'],
		[{ color: [] }, { background: [] }], // dropdown with colors
		[{ list: 'ordered' }, { list: 'bullet' }],
		[{ align: [] }],
		['clean'],
	],
}

const formats = ['header', 'bold', 'italic', 'list', 'bullet', 'link']

export const Editor = ({
	value,
	onChange,
	placeholder,
	className,
}: EditorProps) => {
	return (
		<ReactQuill
			theme="snow"
			value={value}
			onChange={onChange}
			modules={modules}
			formats={formats}
			placeholder={placeholder}
			className={className}
		/>
	)
}
